import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';

import { tradeRewardsLevelUpModalRule } from './tradeRewardsLevelUpModalRule';
import { tradeRewardsLevelUpModalAction } from './tradeRewardsLevelUpModalAction';
import { TABLET, DESKTOP } from '../../../../exports/deviceTypeEnums';

export default {
    name: 'tradeRewardsLevelUp',
    priority: 448,
    rule: tradeRewardsLevelUpModalRule,
    blockedPageTypes: [
        PAGE_TYPE.CHECKOUT,
        PAGE_TYPE.CHECKOUT_CONFIRMATION,
        PAGE_TYPE.ORDER_MANAGER,
        PAGE_TYPE.TRADE_REWARDS,
    ],
    deviceTypes: [TABLET, DESKTOP],
    action: tradeRewardsLevelUpModalAction,
};
